import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchJobs } from "../../features/jobs/jobsSlice";
import HeaderSearch from "./HeaderSearch";
import Job from "./Job";

export default function Jobs(value) {
  const dispatch = useDispatch();
  const { jobs, isLoading, isError, error } = useSelector(
    (state) => state.jobs
  );

  const { search, sort } = useSelector((state) => state.jobs.filter);

  useEffect(() => {
    dispatch(fetchJobs(value.value));
  }, [dispatch, value]);

  const filteredJobs = jobs
    .filter((job) => job.title.toLowerCase().includes(search.toLowerCase()))
    .sort((a, b) => {
      if (sort === "Salary (Low to High)") {
        return a.salary - b.salary;
      } else if (sort === "Salary (High to Low)") {
        return b.salary - a.salary;
      } else {
        return 0;
      }
    });

  // decide what to render
  let content = null;
  if (isLoading) content = <p>Loading...</p>;

  if (!isLoading && isError)
    content = <p className="error">There was an error occured. {error}</p>;

  if (!isLoading && !isError && filteredJobs?.length > 0) {
    content = filteredJobs.map((job) => <Job key={job.id} job={job} />);
  }

  if (!isLoading && !isError && filteredJobs?.length === 0) {
    content = <p>No jobs found!</p>;
  }

  return (
    <main className="max-w-3xl rounded-lg  mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
      <HeaderSearch type={value.value}/>

      <div className="jobs-list ">
        {/* <!-- Single Job 1--> */}
        {content}
        {/* <!-- Single Job 1--> */}
      </div>
    </main>
  );
}
